import React from "react";
import styled from "styled-components";
import { colors } from "../resources/ThemeColors";
import { breakpoints } from "../Media";
import ReadMoreReact from "read-more-react";

const MainDiv = styled.div`
  height: auto;
  width: 60vw;
  margin-top: 0.5em;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  @media (max-width: ${breakpoints.mobileMin}) {
    height: 20%;
    width: 95%;
    border-top: 1px solid ${colors.gray};
    margin-top: 0.4em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    height: 25%;
    width: 95%;
    margin-left: 1em;
    margin-top: 0.4em;
  }
`;

// const ImageDiv = styled.div`
//   height: 8em;
//   width: 12em;
//   border-radius: 12px;
//   background-color: red;
//   padding-left: 2em;
//   @media (max-width: ${breakpoints.mobileMin}) {
//     width: 150px;
//     height: 120px;
//     margin-left: 1.5em;
//   }

//   @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
//     width: 50%;
//     height: 75%;
//     background-color: black;
//   }
// `;

const Image = styled.img`
  height: 8em;
  width: 12em;
  object-fit: cover;
  border-radius: 12px;
  @media (max-width: ${breakpoints.mobileMin}) {
    width: 8em;
    height: 7em;
    margin-left: 1em;
  }
  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    width: 12em;
    height: 8em;
  }
`;

const TextDiv = styled.div`
  width: 45%;
  height: 100%;
  padding: 1em;
  margin-left: 1em;
  @media (max-width: ${breakpoints.mobileMin}) {
    height: 70%;
    width: 55%;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    height: 90%;
    width: 50%;
  }
`;

const SalonTitle = styled.h2`
  font-size: 1.2em;
  font-weight: 500;
  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    font-size: 1.1em;
  }
`;

const SalonDescription = styled.p`
  font-size: 0.9em;
  font-weight: 250;
  margin-top: -0.3em;
  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 0.8em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    font-size: 0.9em;
  }
`;

const SalonServices = styled.p`
  font-size: 0.8em;
  font-weight: 350;
`;

// const ButtonDiv = styled.div``;

const Button = styled.button`
  height: 2em;
  width: 12em;
  background-color: ${colors.main};
  color: ${colors.light};
  border: none;
  border-radius: 6px;
  margin-top: 0.3em;
  font-size: 0.8em;
  font-weight: 700;
  cursor: pointer;
  :focus {
    outline: none;
  }
  @media (max-width: ${breakpoints.mobileMin}) {
    width: auto;
    height: 2.5em;
    font-size: 0.6em;
    padding: 0.6em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    width: auto;
    height: 2em;
    font-size: 0.7em;
    padding: 0.6em;
  }
`;

const Links = styled.a`
  text-decoration: none;
  color: ${colors.main};
`;

function ResultsCard({ salon }) {
  return (
    <MainDiv key={salon.id}>
      {/* <ImageDiv> */}
      <Image src={salon.images} alt={salon.name}></Image>
      {/* </ImageDiv> */}
      <TextDiv>
        <SalonTitle>{salon.name}</SalonTitle>
        <SalonDescription>
          <ReadMoreReact
            text={salon.description}
            min={55}
            ideal={60}
            max={65}
            readMoreText="...read more"
          />
        </SalonDescription>
        <SalonServices>
          {salon.street}, {salon.city}, {salon.post_code}
        </SalonServices>
        <Links href={`/bookings/${salon.id}/${salon.name}`}>
          <Button>Book Appointment</Button>
        </Links>
      </TextDiv>
    </MainDiv>
  );
}

export default ResultsCard;
